function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 3.125,
    style: {
      fill: "#ffe000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.974,
    cy: 15,
    r: 2.571,
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.149,
    cy: 11.875,
    r: 3.274,
    transform: "translate(-6.738 16.997) rotate(-89.872)",
    style: {
      fill: "#ffe000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.764,13.222c.061-.64.091-1.654.091-1.664v-.036s-.19,0-.19,0l.003.037s.022.316-.045.718c-.051.308-.076.405-.116.567-.013.054-.028.115-.047.194-.072.304-.085.339-.147.507l-.006.016c-.065.176-.071.186-.171.345l-.057.091q-.035.055-.053.087l-.025.043c-.01.018-.021.023-.035.03-.015.007-.036.018-.051.045-.023.043-.027.13-.027.14v.036s.874,0,.874,0l.007-.018c.018-.036.035-.111-.017-.154-.017-.014-.041-.023-.069-.033-.088-.032-.114-.052-.094-.107.019-.052.035-.091.048-.125.058-.143.077-.192.127-.719Z",
    style: {
      fill: "#7b3100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.547,9.49c.007.127-.006.295-.059.432-.053.152-.111.304-.109.462-.085.029-.172-.184-.254-.059.061.173.203.309.3.465.016.048.156.174.075.203-.204-.07-.253-.328-.38-.485-.147-.264-.421-.451-.726-.464-.115.003-.487-.028-.39.168.143.097.319.16.46.269.105.01.296.185.284.252-.185-.075-.271-.165-.47-.243-.27-.104-.643-.042-.792.226-.028.07-.069.273.019.292.102-.16.249-.338.466-.29.17.013-.19.317-.052.256.044-.019.145-.086.215-.093.07-.007.109.045.162.053.106.014.135.059.126.085-.012.031-.045.004-.153.039-.054.017-.082.065-.145.086-.063.022-.194.023-.243.004-.171-.074-.452-.061-.505.153,0,.094-.084-.01-.123.03-.029.103-.037.209-.189.199-.093.097-.188.198-.305.267.069.159.343-.159.33-.025-.12.163.062.198.141.072.134-.142.3-.314.501-.171.095.09.151-.047.22-.04.043.112.098.005.148-.026.081-.01.058.101.154.033.191-.127.427-.02.614-.143.199-.091.028.073-.027.137-.087.17-.012.392-.201.497-.076.202.09.468-.079.618-.025.094.218.083.286.122.119.005-.005-.273.113-.31.159.098.151-.176.119-.26.015-.192.026-.402.122-.576.101-.213.195.087.082.171-.065.196-.158.442-.012.624.042.009.077.112.132.143s.13-.008.143-.101c.07-.281.035-.583.135-.856.071-.085.168-.014.212.064.141.163.239.367.41.502.155.073.292.182.363.342,0,.123.35.142.245.005-.101-.133-.034-.266.068-.355.055.013.038-.084-.004-.046-.068-.016-.073-.141.022-.082.16.052-.012-.116-.07-.121-.135-.084-.291-.181-.358-.327.176.002.359.097.54.038.144-.074.291.006.341.134.112-.018.064-.13,0-.167.082-.034.138-.104.039-.165-.052-.068.07-.185-.08-.18.005-.115-.04-.22-.166-.26-.126-.106-.494.157-.483-.083-.037-.13.15-.017.202-.082.054-.137-.257-.124-.154-.231.067-.043.381-.105.135-.151-.123.034-.229.009-.326-.052-.088.148-.34-.08-.295.182-.034.099-.26.356-.321.159.052-.154.319-.205.236-.413-.013-.13-.12.023-.171.013-.026-.081.078-.176.15-.195.143.11.147-.139.283-.118.099-.022-.032-.065-.06-.083.027-.073.18-.11.03-.173-.132-.098-.23.097-.338.108-.104-.118.095-.174.15-.237.003-.046-.116-.014-.08-.054.031-.056.242-.06.143-.143-.149-.051-.341-.038-.483.028-.09.029-.116.232-.194.224-.043-.092.005-.271-.119-.297h0ZM6.25,11.476c.113-.019.002.172-.052.169.005-.069-.164-.062-.059-.122.033-.022.071-.039.111-.047Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M22.5,18.929l.207.642.631-.239-.373.562.58.344-.672.059.093.668-.465-.489-.465.489.093-.668-.672-.059.58-.344-.373-.562.631.239.205-.642Z",
    style: {
      fill: "#ffe000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M18.75,12.991l.207.642.631-.239-.373.562.58.344-.672.059.093.668-.465-.489-.465.489.093-.668-.672-.059.58-.344-.373-.562.631.239.205-.642Z",
    style: {
      fill: "#ffe000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M22.5,8.929l.207.642.631-.239-.373.562.58.344-.672.059.093.668-.465-.489-.465.489.093-.668-.672-.059.58-.344-.373-.562.631.239.205-.642Z",
    style: {
      fill: "#ffe000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M25.833,11.991l.207.642.631-.239-.373.562.58.344-.672.059.093.668-.465-.489-.465.489.093-.668-.672-.059.58-.344-.373-.562.631.239.205-.642Z",
    style: {
      fill: "#ffe000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M24,15l.163.4.431.032-.33.279.103.42-.367-.228-.367.228.103-.42-.33-.279.431-.032.163-.4Z",
    style: {
      fill: "#ffe000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/CC.ebc4c83147a5bed71845084ece692556.svg";
export { ForwardRef as ReactComponent };